import Header from "../../shared/app-shell/Header";
import PageFooter from "../../shared/app-shell/PageFooter";
import Sidebar from "../../shared/app-shell/Sidebar";
import logo from "../../shared/assets/Vector.svg";
import { themeAtom } from "../../shared/atoms";
import LoadingWrapper from "../../shared/components/LoadingWrapper";
import VoyagepnlListTable from "../components/VoyagepnlListTable";
import { VoyagePNLItem } from "../models/VoyagePnLList.model";
import { getVoyagePnlList } from "../services/pnl.service";
import { useAtomValue } from "jotai";
import { useEffect, useState } from "react";
import { twMerge } from "tailwind-merge";

const VoyagePNLList: React.FC = () => {
  const [pnls, setPnls] = useState<VoyagePNLItem[]>([]);
  const [isLoading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const theme = useAtomValue(themeAtom);

  useEffect(() => {
    const fetchPnls = async () => {
      try {
        setLoading(true);
        const response = await getVoyagePnlList();
        setPnls(response);
      } catch {
        setError("Failed to load PNL data.");
      } finally {
        setLoading(false);
      }
    };

    fetchPnls();
  }, []);

  return (
    <LoadingWrapper isLoading={isLoading} loadingIndicatorClassName="text-green" loadingIndicatorSize="lg">
      <div className="flex h-screen">
        <Sidebar />
        <div
          className={twMerge("flex flex-1 flex-col justify-between overflow-y-hidden", theme.home.tailwind.backgound)}
        >
          <Header />
          <div className={twMerge("flex flex-col px-6", theme.home.tailwind.textDefault)}>
            <div>
              <h1 className="mt-4 text-[24px] font-semibold">End of voyage PnL</h1>
              <h3
                className={twMerge(
                  "mt-2 text-sm font-normal",
                  error ? "mb-3" : "mb-14",
                  theme.myVesselsTable.tailwind.textDefault,
                )}
              >
                Review and approve PnL assessments for completed voyages
              </h3>
            </div>

            {error && (
              <div
                className={twMerge(
                  "mb-4 flex rounded-md border border-red-600 bg-red-300 p-1.5 pl-6 text-[14px] text-gray-900",
                )}
              >
                {error}
              </div>
            )}

            <div
              className={twMerge(
                "flex h-[70vh] flex-col gap-3 rounded-lg p-6 shadow-md",
                !pnls || pnls.length === 0 ? "overflow-hidden" : "overflow-auto",
                theme.home.tailwind.panelBackground,
              )}
            >
              <div className="flex justify-start gap-4">
                <img alt="logo" src={logo} />
                <div className="text-2xl font-bold">Pending Review</div>
                <div className="flex-1"></div>
              </div>
              <VoyagepnlListTable data={pnls} />
            </div>
          </div>

          <PageFooter />
        </div>
      </div>
    </LoadingWrapper>
  );
};

export default VoyagePNLList;
